export const REFRESH_SUPPORTED_PLATFORMS = new Set(['facebook', 'twitter', 'youtube']);
